import * as React from 'react';
import { storiesOf } from '@storybook/react';
import { VisualTestContainer } from '../../test/visual/VisualTestContainer';
import { classes, st } from './ColorPicker.visual.st.css';
import { ColorPicker } from '..';
import { ErrorAppearance } from '../internal/ErrorMessageWrapper';
import { Toolbox } from '@wix/wix-ui-icons-common';

class ColorPickerVisual extends React.Component<any> {
  render() {
    const { childProps, errorMessage, suffix, ...rest } = this.props;

    return (
      <VisualTestContainer>
        <ColorPicker
          {...rest}
          errorMessage={errorMessage}
          onChange={() => {}}
          suffix={suffix}
        >
          {childProps.map((props, index) => (
            <ColorPicker.Item key={index} {...props} />
          ))}
        </ColorPicker>
        {errorMessage && (
          <div className={classes.elementBelow}>
            An element below to show the spacing
          </div>
        )}
      </VisualTestContainer>
    );
  }
}

const suffixTestComponentStyle = {
  alignSelf: 'center',
  padding: '3px',
};
const suffixTestComponent = (
  <a href="wix.com" style={suffixTestComponentStyle}>
    +3
  </a>
);

const tests = [
  {
    describe: 'basic',
    its: [
      {
        it: 'default',
        props: {
          childProps: [
            {
              value: 'red',
              'aria-label': 'red color',
            },
            {
              value: 'yellow',
              'aria-label': 'yellow color',
            },
            {
              value: 'green',
              'aria-label': 'green color',
              checked: true,
            },
          ],
        },
      },
      {
        it: 'default',
        props: {
          childProps: [
            {
              value: 'red',
              'aria-label': 'red color',
            },
            {
              value: 'yellow',
              'aria-label': 'yellow color',
              disabled: true,
            },
            {
              value: 'green',
              'aria-label': 'green color',
              checked: true,
              disabled: true,
            },
          ],
        },
      },
      {
        it: 'label',
        props: {
          childProps: [
            {
              value: 'red',
              'aria-label': 'red color',
            },
            {
              value: 'yellow',
              'aria-label': 'yellow color',
              disabled: true,
            },
            {
              value: 'green',
              'aria-label': 'green color',
              checked: true,
              disabled: true,
            },
          ],
          label: 'Choose a color',
        },
      },
      {
        it: 'label with asterisk',
        props: {
          childProps: [
            {
              value: 'red',
              'aria-label': 'red color',
            },
            {
              value: 'yellow',
              'aria-label': 'yellow color',
              disabled: true,
            },
            {
              value: 'green',
              'aria-label': 'green color',
              checked: true,
            },
          ],
          label: 'Choose a color',
          required: true,
          showAsterisk: true,
        },
      },
      {
        it: 'error',
        props: {
          childProps: [
            {
              value: 'red',
              'aria-label': 'red color',
            },
            {
              value: 'yellow',
              'aria-label': 'yellow color',
              disabled: true,
            },
            {
              value: 'green',
              'aria-label': 'green color',
              checked: true,
              disabled: true,
            },
          ],
          errorMessage: 'there was an error',
        },
      },
      {
        it: 'error / ErrorAppearance - BackgroundAndBorder',
        props: {
          childProps: [
            {
              value: 'red',
              'aria-label': 'red color',
            },
            {
              value: 'yellow',
              'aria-label': 'yellow color',
              disabled: true,
            },
            {
              value: 'green',
              'aria-label': 'green color',
              checked: true,
              disabled: true,
            },
          ],
          errorMessage: 'there was an error',
          errorAppearance: ErrorAppearance.BackgroundAndBorder,
        },
      },
      {
        it: 'error with override styles',
        props: {
          childProps: [
            {
              value: 'red',
              'aria-label': 'red color',
            },
            {
              value: 'yellow',
              'aria-label': 'yellow color',
              disabled: true,
            },
            {
              value: 'green',
              'aria-label': 'green color',
              checked: true,
              disabled: true,
            },
          ],
          errorMessage: 'there was an error',
          className: classes.errorOverrides,
        },
      },
      {
        it: 'error with override styles / ErrorAppearance - BackgroundAndBorder',
        props: {
          childProps: [
            {
              value: 'red',
              'aria-label': 'red color',
            },
            {
              value: 'yellow',
              'aria-label': 'yellow color',
              disabled: true,
            },
            {
              value: 'green',
              'aria-label': 'green color',
              checked: true,
              disabled: true,
            },
          ],
          errorMessage: 'there was an error',
          errorAppearance: ErrorAppearance.BackgroundAndBorder,
          className: classes.errorOverrides,
        },
      },
      {
        it: 'item style overrides',
        props: {
          childProps: [
            {
              value: 'red',
              'aria-label': 'red color',
            },
            {
              value: 'yellow',
              'aria-label': 'yellow color',
            },
            {
              value: 'green',
              'aria-label': 'green color',
              checked: true,
            },
          ],
          className: classes.colorOptionOverrides,
        },
      },
      {
        it: 'label style overrides',
        props: {
          childProps: [
            {
              value: 'red',
              'aria-label': 'red color',
            },
            {
              value: 'yellow',
              'aria-label': 'yellow color',
            },
            {
              value: 'green',
              'aria-label': 'green color',
              checked: true,
            },
          ],
          label: 'Choose a color',
          className: classes.labelOverrides,
        },
      },
      {
        it: 'suffix',
        props: {
          childProps: [
            {
              value: 'red',
              'aria-label': 'red color',
              checked: true,
            },
            {
              value: 'yellow',
              'aria-label': 'yellow color',
              disabled: true,
            },
            {
              value: 'green',
              'aria-label': 'green color',
              disabled: true,
            },
          ],
          label: 'Choose a color',
          suffix: suffixTestComponent,
        },
      },
      {
        it: 'image',
        props: {
          childProps: [
            {
              value: 'red',
              'aria-label': 'red color',
              imageSrc: '502a39_5f286da347284d3fae059fd38dac576a~mv2.jpg',
            },
            {
              value: 'yellow',
              'aria-label': 'yellow color',
            },
            {
              value: 'green',
              'aria-label': 'green color',
              checked: true,
            },
          ],
        },
      },
    ],
  },
  {
    describe: 'loading state',
    its: [
      {
        it: 'default loading state',
        props: {
          childProps: [
            {
              value: 'red',
              'aria-label': 'red color',
            },
            {
              value: 'yellow',
              'aria-label': 'yellow color',
            },
            {
              value: 'green',
              'aria-label': 'green color',
              checked: true,
            },
          ],
          className: classes.notAnimated,
          isLoading: true,
        },
      },
      {
        it: 'default loading state - Style override',
        props: {
          childProps: [
            {
              value: 'red',
              'aria-label': 'red color',
            },
            {
              value: 'yellow',
              'aria-label': 'yellow color',
            },
            {
              value: 'green',
              'aria-label': 'green color',
              checked: true,
            },
          ],
          className: st(classes.colorOptionOverrides, {}, classes.notAnimated),
          isLoading: true,
        },
      },
    ],
  },
];

tests.forEach(({ describe, its }) => {
  its.forEach(({ it, props }) => {
    storiesOf(`ColorPicker/${describe}`, module).add(it, () => (
      <ColorPickerVisual {...props} />
    ));
  });
});

const WstTest = ({
  variables,
}: {
  variables: Record<`--wst-${string}`, string>;
}) => {
  const children = [
    { value: 'red', disabled: true },
    { value: 'yellow', isCrossedOut: true },
    { value: 'green', checked: true },
  ].map((props) => <ColorPicker.Item {...props} />);

  return (
    <div style={{ ...variables }}>
      <ColorPicker
        className={classes.notAnimated}
        label="Loading"
        isLoading
        children={children}
        suffix={<Toolbox />}
      />
      <ColorPicker label="Label" showAsterisk required children={children} />
      <ColorPicker
        label="With suffix"
        showAsterisk
        required
        children={children}
        suffix="more items?"
      />
      <ColorPicker
        label="Error"
        errorMessage="This is an error"
        showAsterisk
        required
        children={children}
        suffix={<Toolbox />}
      />
    </div>
  );
};

storiesOf('ColorPicker/wst variables', module)
  .add('paragraph 2', () => (
    <WstTest
      variables={{
        '--wst-paragraph-2-color-rgb': '0,255,0',
        '--wst-paragraph-2-font-family': 'Monospace',
        '--wst-paragraph-2-font-variant': 'small-caps',
        '--wst-paragraph-2-font-style': 'italic',
        '--wst-paragraph-2-font-size': '22px',
        '--wst-paragraph-2-font-weight': '900',
      }}
    />
  ))
  .add('system error color', () => (
    <WstTest
      variables={{
        '--wst-system-error-color-rgb': '0,255,0',
      }}
    />
  ));
